import React, { useState } from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { RiErrorWarningFill } from "react-icons/all";
import WithdrawSelectDrop from "../withdraw_select/withdrawSelectDrop";

export default function WithdrawDropdown({walletInfo}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const renderTooltip = (props: any) => (
    <Tooltip id="overlay-right" {...props}>
      After you enter withdrawal address, if there are multiple networks, the
      system will automatically match the corresponding network for you. When
      the special coin cannot match the network, you need to confirm the network
      of the receiving address for selection. Please confirm with the
      platform/wallet of the receiving address first to avoid the situation that
      the withdrawal of coins cannot be received due to the wrong network
      selection.
    </Tooltip>
  );

  return (
    <>
      <div className="mt-3" style={{ color: "var(--text-clr)" }}>
        <div style={{ cursor: "pointer" }}>
          <div className="mb-2">
            <span className="">Network</span>
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <button style={{background: 'none', border: 'none'}}>
                  <RiErrorWarningFill />
                </button>
              </OverlayTrigger>
          </div>
          <WithdrawSelectDrop walletInfo={walletInfo}/>
        </div>
      </div>
    </>
  );
}
